import Enum from './enum'

class LotCountType extends Enum
{
  constructor(value) {
    super(value);
  }
}

LotCountType.init({
  EMPTY: 'None',
  SINGLE: 'Single',
  MULTIPLE: 'Multi'
}, {
  EMPTY: 'lot-count-type.empty',
  SINGLE: 'lot-count-type.single',
  MULTIPLE: 'lot-count-type.multiple'
});

export default LotCountType;
